import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { HelmetProvider } from "react-helmet-async";
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/index';
import { fetchJobs, selectJobsStatus } from './store/jobsSlice';
import AppRoutes from "./routes/Routes";
import Layout from "./components/Layouts/Layout";
import ScrollToTop from './components/scrollTop';
import CookieConsentBanner from './components/coockies';
import theme from "./components/theme/Theme";
import './global.css';

// Create a separate component for the app content that uses Redux hooks
const AppContent = () => {
  const dispatch = useDispatch();
  const jobsStatus = useSelector(selectJobsStatus);

  useEffect(() => {
    // Fetch jobs when the app loads for the first time
    if (jobsStatus === 'idle') {
      console.log('Fetching jobs on app load...');
      dispatch(fetchJobs());
    }
  }, [dispatch, jobsStatus]);

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}> 
        <Router>
          <Layout>
            <ScrollToTop />
            <AppRoutes />
            {/* <CookieConsentBanner /> */}
          </Layout>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;